import { Component, inject, Input, OnInit } from '@angular/core';
import { BpmService } from '@app/_services/bpm.service';
import { Observable, of } from 'rxjs';
import { ActivityInstance } from '@app/_models/activity-instance.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { IconsProviderModule } from '@app/icons-provider.module';


@Component({
  selector: 'app-process-history',
  templateUrl: './process-history.component.html',
  imports: [
    CommonModule,
    FormsModule,
    NzTimelineModule,
    NzTagModule,
    NzToolTipModule,
    IconsProviderModule
  ]
})
export class ProcessHistoryComponent implements OnInit {
  private bpmService = inject(BpmService);


  @Input()
  taskId!: string;

  @Input()
  historic = false;

  processInstanceId!: string;
  processInstance?: any;
  tasks!: any;
  activityInstances!: ActivityInstance;
  users: any = {};

  ngOnInit(): void {
    if (this.historic) {
      this.loadHistoricProcessInstanceDetails();
    } else {
      this.loadProcessInstanceDetails();
    }
  }

  loadProcessInstanceDetails() {
    this.bpmService.task(this.taskId).subscribe(
      data => {
        this.processInstanceId = data.processInstanceId;
        this.loadHistory();
      }
    );
  }

  loadHistoricProcessInstanceDetails() {
    this.bpmService.historicTask(this.taskId).subscribe(
      data => {
        this.processInstanceId = data.processInstanceId;
        this.loadHistory();
      }
    );
  }

  loadHistory() {
    if (this.processInstanceId) {
      this.bpmService.historicProcessInstance(this.processInstanceId).subscribe((value: any) => {
        this.processInstance = value;
      });
      this.bpmService.historicTasksByProcessInstanceId(this.processInstanceId).subscribe((value: any) => {
        this.tasks = value;
      });
      this.bpmService.historicActivitiesByProcessInstanceId(this.processInstanceId).subscribe((value: any) => {
        this.activityInstances = value;
      });
    }
  }

  userInfo(userId: string): Observable<any> {
    if (userId === '$INITIATOR') {
      return of({});
    }
    if (!(userId in this.users)) {
      console.log(userId);
      this.users[userId] = this.bpmService.user(userId);
    }
    return this.users[userId];
  }
}
